import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Button,
  MenuItem,
  Select,
  TextField,
  Modal,
  IconButton,
  Divider,
  FormHelperText,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import useNotify from "../utils/useNotify";
import { useSetRecoilState } from "recoil";
import { showloader } from "../store/gloabalState";
import CloseIcon from "@mui/icons-material/Close";
import { TransactionFilesUpload, TransactionFilesUploadInward } from "../config/globalVar";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { getPresignedURL, setFileMetaData } from "../services/httpCalls";
import { checkFileExtension } from "../utils/check-file-extension";
const style = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  height: "auto",
  borderRadius: "10px",
  bgcolor: "background.paper",

  boxShadow: 24,
  p: 2,
};
const TransactionFileUpload = ({ transactionId, productType }) => {
  const [open, setOpen] = useState(false);
  const [doctype, setDocType] = useState("");
  const [files, setFiles] = useState();
  const [fileName, setFileName] = useState("");
  const setShowLoader = useSetRecoilState(showloader);
  const [otherFlag, setOtherFlag] = useState(false);
  const [otherType, setOtherDocument] = useState();
  const inputfileRef = useRef();
  let notify = useNotify();
  const uploadFileToS3 = (url, file) => {
    return fetch(url, {
      method: "PUT",
      body: file,
      headers: { "Content-Type": file.type },
    });
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const resetFile = () => {
    inputfileRef.current.value = null;
    setFiles(null);
    setFileName(null);
    setDocType("");
  };
  const sendFileandMetaData = async () => {
    if (files) {
      const uploadDoc = (e) => {
        getPresignedURL(transactionId, e[0]?.name)
          .then((res) => {
            const url = res?.preSignedUrl;
            uploadFileToS3(url, e[0]).then((res) => {
              const newPresSigned = url.split("?")[0];

              const decodedurl = decodeURI(newPresSigned);
              let MetaData = {
                fileMetaList: [
                  {
                    url: decodedurl,
                    documentType: doctype,
                  },
                ],
              };
              if (otherType) {
                MetaData.fileMetaList = [
                  {
                    url: decodedurl,
                    documentType: "OTHER_DOCUMENT_TYPE",
                    otherDocumentType: otherType,
                  },
                ];
              }
              setFileMetaData(transactionId, MetaData)
                .then((res) => {
                  if (res) {
                    notify.success("File and Type Upload Successfull");
                    resetFile();

                    handleClose();
                    setShowLoader(false);
                  } else {
                    notify.error("Not uploaded!");
                    resetFile();
                    setShowLoader(false);
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            });
          })
          .catch((error) => {
            notify.error("Not able to Upload the file!");
            console.log("error", error);
            setShowLoader(false);
          });
      };
      await uploadDoc(files);
    } else {
      notify.error("No file Selected!");
    }
  };
  
  return (
    <Box>
      <Button
        onClick={handleOpen}
        startIcon={<UploadFileIcon />}
        variant="contained"
      >
        File upload
      </Button>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 1,
                ml: 0.5,
              }}
            >
              UPLOAD FILE
            </Typography>
            <Box>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
          <Divider
            sx={{
              borderBottom: "1px solid",
            }}
          />
          <Box sx={{}}>
            <FormControl
              sx={{
                mt: "20px",
              }}
              fullWidth
            >
              <InputLabel>Documents</InputLabel>
              <Select
                label="Documents"
                value={doctype}
                onChange={(e) => {
                  if (e.target.value === "OTHER_DOCUMENT_TYPE") {
                    setOtherFlag(true);
                    setDocType(e.target.value);
                  } else {
                    setDocType(e.target.value);
                    setOtherFlag(false);
                  }
                }}
              >
                {productType === "OUTWARD" && TransactionFilesUpload.map((item, index) => {
                  return (
                    <MenuItem value={item.value} key={index}>
                      {item.text}
                    </MenuItem>
                  );
                })}
                {productType === "INWARD" && TransactionFilesUploadInward.map((item, index) => {
                  return (
                    <MenuItem value={item.value} key={index}>
                      {item.text}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            {otherFlag ? (
              <>
                <Box>
                  <FormControl
                    fullWidth
                    sx={{
                      mt: 3,
                    }}
                  >
                    <TextField
                      label="Others"
                      placeholder="please specify other type of docs"
                      onChange={(e) => {
                        setOtherDocument(e.target.value);
                      }}
                    />
                  </FormControl>
                </Box>
              </>
            ) : (
              ""
            )}
            <Box marginTop={3}>
              <FormControl fullWidth>
                <TextField
                  type="file"
                  label="Upload File"
                  inputRef={inputfileRef}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => { 
                    if (e.target.files?.length > 0 ) {
                      if(checkFileExtension(e.target.files[0]?.name)){
                        setFiles(e.target.files);
                        setFileName(e.target.files[0]?.name);
                      } else {
                        notify.error("Please select the correct file type!")
                        resetFile();
                      }
                    } else {
                      notify.error("No File Selected!");
                      resetFile();
                    }
                  }}
                />
              </FormControl>
            </Box>
            <Box marginTop={2} sx={{}}>
              <Button
                variant="contained"
                onClick={() => {
                  sendFileandMetaData();
                }}
                disabled={doctype ? false : true}
              >
                Submit
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default TransactionFileUpload;
